import React from 'react';
import PropTypes from 'prop-types';

const ExtraInfo = ({ extraInfo = [] }) => {
  return extraInfo && extraInfo.length > 0
    ? extraInfo.map(
        i =>
          i.desc && (
            <div key={i.title} className="extra-item">
              <p className="align-left">{i.title}</p>
              <p className="align-left">{i.desc}</p>
            </div>
          )
      )
    : null;
};

ExtraInfo.propTypes = {
  extraInfo: PropTypes.array
};

export default ExtraInfo;
